import { render, staticRenderFns } from "./acbalance-1-report.vue?vue&type=template&id=2ff143a2"
import script from "./acbalance-1-report.vue?vue&type=script&lang=js"
export * from "./acbalance-1-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports